import { Box, Typography } from "@mui/material";
import { useState } from "react";
import walletcoveredbg from "../../../../media/images/walletcoverdbg.svg";
import MobileHeader from "../../../layout/DriverLayout/Header";
import BannerBox from "./BannerBox";
import ChargeWalletBox from "./chargeBox";
import Transactions from "./Transactions";

export default function WalletPage() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Box
        sx={{
          //   border: "1px solid gray",
          backgroundImage: `
              url(${walletcoveredbg})
              `,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <MobileHeader
          title={
            <Typography
              sx={{
                fontWeight: 600,
                color: "secondary.main",
                fontSize: 16,
              }}
            >
              کیف پول{" "}
            </Typography>
          }
        />
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            paddingTop: "8px",
          }}
        >
          <Box
            sx={{
              paddingX: "8px",
            }}
          >
            <BannerBox />
            <ChargeWalletBox handleTransactionsList={setOpen} />
          </Box>

          <Transactions onDismiss={setOpen} open={open} />
        </Box>
      </Box>
    </>
  );
}
